module.exports = __webpack_public_path__ + "static/media/header.33cb1926.png";